export default class Wishlist {
    constructor() {
        this.addToWishlistBtns =
            document.getElementsByClassName("jsAddToWishlist");

        if (this.addToWishlistBtns) {
            this.events();
        }
    }

    events() {
        const self = this;
        for (const item of this.addToWishlistBtns) {
            item.addEventListener("click", function (e) {
                e.preventDefault();
                self.addToWishlist(this);
            });
        }
    }

    addToWishlist(item) {
        const self = this;
        const data = {
            action: "addToWishlist",
            productId: item.dataset.productId,
        };

        jQuery.ajax({
            url: ajax.ajaxurl,
            type: "POST",
            data: data,
            beforeSend: function () {},
            success: function (response) {
                if (response) {
                    self.toggleActive(data.productId);

                    if (item.dataset.removable) {
                        const el = document.querySelector(
                            "#" +
                                item.dataset.removableId +
                                "-" +
                                item.dataset.productId
                        );
                        const speed = 500;
                        const seconds = speed / 1000;
                        el.style.transition = "opacity " + seconds + "s ease";
                        el.style.opacity = 0;

                        setTimeout(function () {
                            el.remove();
                        }, speed);
                    }
                }
            },
            error: function (request) {
                console.log(request.responseText);
            },
        });
    }

    toggleActive(productId) {
        for (const item of this.addToWishlistBtns) {
            if (item.dataset.productId == productId) {
                item.classList.toggle("active");

                if (item.classList.contains("active")) {
                    if (fbq && typeof fbq === "function") {
                        fbq("track", "AddToWishlist", {
                            content_ids: productId,
                        });
                    }
                }
            }
        }
    }
}
